import axiosInstance from "../../axios";

export const referrals = {
  listByEld: async (
    eldType: string,
    page?: number,
    perPage?: number,
    status?: string
  ) => {
    try {
      const response = await axiosInstance.get(`/referrals/list-by-eld`, {
        params: {
          eldType,
          page,
          perPage,
          status,
        },
      });

      return response.data;
    } catch (error) {
      console.error("List error:", error);
      throw error;
    }
  },

  createByEld: async (
    eldType: string,
    body: { name: string; manager: string }
  ) => {
    try {
      const response = await axiosInstance.post(
        `/referrals/create-by-eld`,
        body,
        {
          params: { eldType },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Create error:", error);
      throw error;
    }
  },
  editByEld: async (
    referralId: string | number,
    eldType: string,
    body: { status: string }
  ) => {
    try {
      const response = await axiosInstance.patch(
        `/referrals/edit-by-eld/${referralId}`,
        body,
        {
          params: { eldType },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Edit error:", error);
      throw error;
    }
  },
};
